import React from "react";
import { Box, Typography, Button, IconButton, Grid } from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";

const NoClasseEnrolledScreen = ({
  text,
  subText,
  maxWidth,
  buttonTitle,
  redirectionLink,
  showButton = true,
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (redirectionLink) {
      navigate(redirectionLink);
    } else {
      navigate("/test-prep/classes");
    }
  };

  return (
    <Box
      sx={{
        maxWidth: maxWidth ? maxWidth : 800,
        mx: "auto",

        p: 8,
        px: { xs: 2, sm: 7, md: 15 },
        textAlign: "center",
        borderRadius: 4,
        backgroundColor: "#fff",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        position: "relative",
      }}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        sx={{
          width: "90px",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9241.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Box
        position="absolute"
        bottom={0}
        right={0}
        sx={{
          width: "90px",
          borderBottomRightRadius: "15px",
          borderBottomLeftRadius: "2px",
          overflow: "hidden",
        }}
      >
        <img
          src="/newdashboard/Wishlist/Ellipse 9240.png"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box
            sx={{
              width: 70,
              height: 70,
              mx: "auto",
            }}
          >
            <img src="/newdashboard/Classrom/Group 1171283373.png" />
          </Box>
        </Grid>

        {/* Title */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="24px"
            color="#9D0385"
            sx={{
              fontWeight: 700,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: "100%",
            }}
          >
            {text}
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="16px"
            color="#555555"
            sx={{
              fontWeight: 400,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: 1.5,
            }}
          >
            {subText}
          </Typography>
        </Grid>

        {/* Button */}
        {showButton && (
          <Grid item xs={12} mt={1}>
            {" "}
            <Button
              variant="contained"
              color="secondary"
              startIcon={<SearchIcon />}
              onClick={handleNavigate}
              style={{
                background: "#9D0385",
                fontWeight: 700,
                borderRadius: "8px",
                fontSize: "16px",
                paddingLeft: 20,
                paddingRight: 20,
                fontFamily: "Inter",
                height: "32px",
                color: "#ffffff",
                "&:hover": {
                  textDecoration: "none",
                },
              }}
              sx={{
                width: {
                  xs: "100%", // full width on small screens
                  sm: "60%", // 48% from 'sm' breakpoint and up
                  md: "40%",
                },
              }}
            >
              {buttonTitle ? buttonTitle : "Explore Classes"}
            </Button>{" "}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default NoClasseEnrolledScreen;
